import Vue from 'vue'
import App from './App.vue'
import { sync } from 'vuex-router-sync'
import router from './router'
import store from './store'
import './registerServiceWorker'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Buefy from 'buefy'
import Transitions from 'vue2-transitions'
import VueCountdown from '@xkeshi/vue-countdown'
import vueHeadful from 'vue-headful'
import Datetime from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
import Meta from 'vue-meta'
import Croppa from 'vue-croppa'
import 'vue-croppa/dist/vue-croppa.css'

Vue.config.productionTip = false
sync(store, router)

// configure the api connection
let host = window.location.hostname
if (host === 'ploylist.com') {
  host = 'admin.ploylist.com'
}
let apiUrl = window.location.protocol + '//' + host
if (window.location.hostname !== 'ploylist.com') {
  apiUrl += ':8000'
}
apiUrl += '/api'
let api = axios.create({
  baseURL: apiUrl,
  timeout: 15000,
  addTrailingSlash: true
})
api.interceptors.request.use((config) => {
  if (config.addTrailingSlash && config.url[config.url.length - 1] !== '/') {
    config.url += '/'
  }
  return config
})

Vue.use(Datetime)
Vue.use(VueAxios, api)
Vue.use(Transitions)
Vue.use(Buefy)
Vue.use(Meta)
Vue.use(Croppa)
window.axios = api
Vue.component('countdown', VueCountdown)
Vue.component('vue-headful', vueHeadful)

Vue.filter('linebreaks', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.replace(/\n/g, '<br/>')
})
Vue.filter('truncate', function (value, chars) {
  if (!value) return ''
  if (value.length > chars) return value.substring(0, chars) + '...'
  else return value
})
Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
